import { Link } from 'react-router';

interface PlaceholderPageProps {
  title: string;
  description: string;
}

export function PlaceholderPage({
  title,
  description,
}: PlaceholderPageProps) {
  return (
    <section className="placeholder-page">
      <p className="eyebrow">Coming soon</p>
      <h1>{title}</h1>
      <p className="hero-description">{description}</p>

      <Link className="secondary-button button-link" to="/">
        Back to portal
      </Link>
    </section>
  );
}